<template>
	<div class="overview_main">
		<div class="main_t">
			<el-card class="card_box">
				<div slot="header" class="card_title">
					<span>各版块流量统计</span>
				</div>
				<div class="card_content">
					<div class="card_content_search card_content_search_1">
						<div class="card_content_search_item">
							<el-date-picker
								class="responsive-date-picker"
								v-model="pageDateRange"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								:unlink-panels="true"
								@change="handlePageDateChange"
							>
							</el-date-picker>
							<div
								class="card_content_search_select card_content_search_select_1"
							>
								<div class="card_content_search_select_title">类型:</div>
								<el-select
									class="custom_input_80 card_content_search_select_item"
									v-model="pageInfo.type"
									placeholder="全部"
								>
									<el-option label="PV" value="pv"></el-option>
									<el-option label="UV" value="uv"></el-option>
									<el-option label="APP" value="app"></el-option>
								</el-select>
							</div>
							<div
								class="card_content_search_select card_content_search_select_1"
							>
								<div class="card_content_search_select_title">周期:</div>
								<el-select
									class="custom_input_80 card_content_search_select_item"
									v-model="pageInfo.time"
									placeholder="全部"
								>
									<el-option label="天" value="day"></el-option>
									<el-option label="小时" value="hour"></el-option>
								</el-select>
							</div>
						</div>
						<div class="card_content_search_item_r">
							<div
								class="card_content_search_item_btn pointer"
								@click="pageDataSeach()"
							>
								查询
							</div>
							<div
								class="card_content_search_item_btn card_content_search_item_btn_export card_content_search_item_btn_export_2 pointer"
								@click="pageDataExport()"
							>
								导出Excel
							</div>
							<div
								class="card_content_search_item_btn card_content_search_item_btn_export card_content_search_item_btn_export_1 pointer"
								@click="pageDataExport()"
							>
								导出
							</div>
						</div>
					</div>
					<div class="card_content_table">
						<div id="card_content_tabledata"></div>
					</div>
				</div>
			</el-card>
			<el-card class="card_box">
				<div slot="header" class="card_title">
					<span>员工数据看板</span>
				</div>
				<div class="card_content">
					<div class="card_content_search">
						<div class="card_content_search_item">
							<el-date-picker
								class="responsive-date-picker"
								v-model="peopleDateRange"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								:unlink-panels="true"
								@change="handlePeopleDateChange"
							>
							</el-date-picker>
						</div>
						<div class="card_content_search_item_r">
							<div
								class="card_content_search_item_btn pointer"
								@click="peopleDataSeach('uv')"
							>
								查询
							</div>
							<div
								class="card_content_search_item_btn card_content_search_item_btn_export pointer"
								@click="peopleDataExport()"
							>
								导出Excel
							</div>
						</div>
					</div>
					<div style="height: 20px"></div>
					<div class="card_content_table">
						<peopleTable :tableData="peopleData"></peopleTable>
					</div>
				</div>
			</el-card>
		</div>
		<div class="main_b">
			<el-card class="card_box card_box1">
				<div slot="header" class="card_title">
					<span>内容排行榜</span>
				</div>

				<div class="card_content">
					<div class="card_content_search">
						<div class="card_content_search_item">
							<el-date-picker
								v-model="articleDateRange"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								:unlink-panels="true"
								@change="handleArticleDateChange"
							>
							</el-date-picker>
							<div class="card_content_search_select">
								<div class="card_content_search_select_title">文章ID:</div>
								<el-input
									class="custom_input_150"
									v-model="articleInfo.id"
									placeholder="输入文章ID"
									clearable
								>
								</el-input>
							</div>
							<div class="card_content_search_select">
								<div class="card_content_search_select_title">数量:</div>
								<el-select class="custom_input_100" v-model="articleInfo.size">
									<el-option label="10条" value="10"></el-option>
									<el-option label="20条" value="20"></el-option>
									<el-option label="50条" value="50"></el-option>
									<el-option label="100条" value="100"></el-option>
									<el-option label="1000条" value="1000"> </el-option>
								</el-select>
							</div>
							<div class="card_content_search_select">
								<div class="card_content_search_select_title">文章类型:</div>
								<el-select
									class="custom_input_80"
									v-model="articleInfo.type"
									placeholder="全部"
								>
									<el-option label="全部" value="0"></el-option>
									<el-option label="文章" value="1"></el-option>
									<el-option label="快讯" value="2"></el-option>
									<el-option label="专栏" value="5"></el-option>
									<el-option label="活动" value="7"> </el-option>
								</el-select>
							</div>
							<div class="card_content_search_select" style="display: none">
								<div class="card_content_search_select_title">内容类型:</div>
								<el-select
									class="custom_input_80"
									v-model="articleInfo.is_ai"
									placeholder="全部"
								>
									<el-option label="全部" value="999"></el-option>
									<el-option label="AI" value="1"></el-option>
									<el-option label="Crypto" value="0"></el-option>
								</el-select>
							</div>
							<div class="card_content_search_select">
								<div class="card_content_search_select_title">操作类型:</div>
								<el-select
									class="custom_input_120"
									v-model="articleInfo.option_type"
									placeholder="全部"
								>
									<el-option label="全部" value="999"></el-option>
									<el-option label="人工原创" value="1"></el-option>
									<el-option label="AI原创" value="2"></el-option>
									<el-option label="AI转载" value="3"></el-option>
									<el-option label="人工转载" value="4"></el-option>
									<el-option label="PR" value="5"></el-option>
								</el-select>
							</div>
						</div>

						<div class="card_content_search_item_r">
							<div
								class="card_content_search_item_btn pointer"
								@click="getAticleData()"
							>
								查询
							</div>
							<div
								class="card_content_search_item_btn card_content_search_item_btn_export pointer"
								@click="articleDataExport()"
							>
								导出Excel
							</div>
						</div>
					</div>
					<div style="height: 20px"></div>
					<div class="card_content_table">
						<articleTable :tableData="articleData"></articleTable>
					</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import peopleTable from "./peopleTable.vue";
import articleTable from "./articleTable.vue";
import * as echarts from "echarts";
import {
	peopleData,
	pageData,
	pageDataNew,
	getInformationList,
} from "@/api/article";
export default {
	components: {
		peopleTable,
		articleTable,
	},
	name: "home",
	data() {
		return {
			pageDateRange: [this.getLast30Days()[0], this.getLast30Days()[1]], // 用于绑定日期范围
			pageInfo: {
				startDate: this.getLast30Days()[0],
				endDate: this.getLast30Days()[1],
				type: "pv",
				time: "day",
			},
			pageData: [],
			peopleDateRange: [this.getLast30Days()[0], this.getLast30Days()[1]], // 用于绑定日期范围
			peopleInfo: {
				startDate: this.getLast30Days()[0],
				endDate: this.getLast30Days()[1],
			},
			peopleData: [],

			articleDateRange: [this.getLast30Days()[0], this.getLast30Days()[1]], // 用于绑定日期范围
			articleInfo: {
				startDate: this.getLast30Days()[0],
				endDate: this.getLast30Days()[1],
				type: "0",
				page: 1,
				size: "10",
				order: "pv",
				pv: "1",
				is_ai: "999",
				option_type: "999",
				id: "",
			},
			articleData: [],
			myChart: null,
			chartLoading: false, // 新增图表加载状态
		};
	},
	mounted() {
		this.getPageData();
		this.getPeopleData();
		this.getAticleData();
	},
	created: {},
	methods: {
		pageDataExport() {
			this.downloadLoading = true;
			let headers = [];
			let fields = [];

			if (this.pageInfo.type == "app") {
				headers = ["时间", "iOS日活", "Android日活"];
				fields = ["date", "ios_count", "android_count"];
			} else {
				headers = [
					"时间",
					"文章",
					"快讯",
					"活动",
					"专栏",
					"HK",
					"US",
					"DataEra",
					"Poly",
					"AIMPACT",
					"合计",
				];
				fields = [
					"date",
					"contents_count",
					"news_count",
					"events_count",
					"columns_count",
					"hk_count",
					"us_count",
					"dataera_count",
					"poly_count",
					"aimpact_count",
					"total_count",
				];
			}

			console.log(data);
			console.log(headers);
			console.log(fields);
			// 对应接口字段
			const formatDataForExcel = (data) => {
				const rows = data.map((item) =>
					fields.map((field) => {
						return item[field];
					}),
				);
				return [headers, ...rows]; // 第一行是表头
			};
			var data = this.pageData;

			// 将 JSON 数据转换为工作簿对象
			const ws = XLSX.utils.aoa_to_sheet(formatDataForExcel(data));
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

			// 生成二进制字符串
			const wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});

			// 保存文件
			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: "application/octet-stream",
					}),
					this.pageInfo.type + ".xlsx",
				);
			} catch (e) {
				if (typeof console !== "undefined") console.log(e, wbout);
			}
		},
		peopleDataExport() {
			// 获取表格元素
			const table = document.querySelector("#peopleTable");

			// 将表格转换为工作簿对象
			let wb = XLSX.utils.table_to_book(table, { raw: true });

			// 获取第一个工作表
			let ws = wb.Sheets[wb.SheetNames[0]];

			// 获取二进制字符串作为输出
			var wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});

			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: "application/octet-stream",
					}),
					"员工数据表" + ".xlsx",
				);
			} catch (e) {
				if (typeof console !== "undefined") console.log(e, wbout);
			}

			this.downloadLoading = false;
			return wbout;
		},
		articleDataExport() {
			this.downloadLoading = true;
			const headers = [
				"资讯ID",
				"资讯标题",
				"文章类型",
				"内容类型",
				"操作类型",
				"操作人",
				"作者",
				"阅读量",
				"PC网页",
				"H5网页",
				"APP",
				"发布时间",
				"状态",
				"链接",
			];
			const fields = [
				"id",
				"title",
				"type",
				"is_ai",
				"edit_type",
				"adminName",
				"nickname",
				"pv",
				"pc_pv",
				"h5_pv",
				"app_pv",
				"release_time",
				"status",
				"link",
			]; // 对应接口字段
			const formatDataForExcel = (data) => {
				const rows = data.map((item) =>
					fields.map((field) => {
						// 可以在此对字段值进行格式化处理，例如转换状态码为文字
						if (field === "status") {
							return item[field] === 1
								? "已发布"
								: item[field] === 2
								? "待发布"
								: "草稿箱";
						} else if (field === "type") {
							return item[field] === 1
								? "文章"
								: item[field] === 2
								? "快讯"
								: item[field] === 5
								? "专栏"
								: item[field] === 7
								? "活动"
								: "";
						} else if (field === "is_ai") {
							return item[field] === 1
								? "AI"
								: item[field] === 0
								? "Crypto"
								: "";
						} else if (field === "edit_type") {
							return item[field] === 1
								? "PR"
								: item[field] === 2
								? "人工原创"
								: item[field] === 6
								? "AI原创"
								: item[field] === 3
								? "翻译"
								: item[field] === 4
								? "转载"
								: item[field] === 5
								? "审核"
								: "";
						} else if (field === "link") {
							if (item["type"] == 2) {
								return "https://me.news/news/" + item["id"];
							} else {
								return "https://me.news/contents/" + item["id"];
							}
						}
						return item[field];
					}),
				);
				return [headers, ...rows]; // 第一行是表头
			};
			var data = this.articleData;
			// 将 JSON 数据转换为工作簿对象
			const ws = XLSX.utils.aoa_to_sheet(formatDataForExcel(data));
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

			// 生成二进制字符串
			const wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});

			// 保存文件
			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: "application/octet-stream",
					}),
					"内容排行表" + ".xlsx",
				);
			} catch (e) {
				if (typeof console !== "undefined") console.log(e, wbout);
			}
		},
		peopleDataSeach() {
			this.getPeopleData();
		},
		pageDataSeach() {
			this.getPageData();
		},
		handleArticleDateChange(val) {
			if (val && val.length === 2) {
				this.articleInfo.startDate = val[0];
				this.articleInfo.endDate = val[1];
			} else {
				this.articleInfo.startDate = "";
				this.articleInfo.endDate = "";
			}
		},
		handlePageDateChange(val) {
			if (val && val.length === 2) {
				this.pageInfo.startDate = val[0];
				this.pageInfo.endDate = val[1];
			} else {
				this.pageInfo.startDate = "";
				this.pageInfo.endDate = "";
			}
		},
		handlePeopleDateChange(val) {
			if (val && val.length === 2) {
				this.peopleInfo.startDate = val[0];
				this.peopleInfo.endDate = val[1];
			} else {
				this.peopleInfo.startDate = "";
				this.peopleInfo.endDate = "";
			}
		},
		getLast30Days() {
			const today = new Date();
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(today.getDate() - 30);

			const formatDate = (date) => {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, "0");
				const day = String(date.getDate()).padStart(2, "0");
				return `${year}-${month}-${day}`;
			};

			return [formatDate(thirtyDaysAgo), formatDate(today)];
		},
		getPageData() {
			if (this.myChart) {
				this.myChart.showLoading("default", {
					text: "数据加载中...",
					color: "#409EFF",
					textColor: "#333",
					maskColor: "rgba(255, 255, 255, 0.8)",
					zlevel: 0,
				});
			}
			pageDataNew(this.pageInfo).then((res) => {
				this.loading = false;
				if (this.myChart) {
					this.myChart.hideLoading();
				}
				if (res.code == 200) {
					this.pageData = res.data;
					this.initChart(res.data);
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getPeopleData() {
			peopleData(this.peopleInfo).then((res) => {
				if (res.code == 200) {
					var peopleData = [];
					for (let index = 0; index < res.data.list.length; index++) {
						const element = res.data.list[index];

						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 1,
							count: element.pr_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 2,
							count: element.yc_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 3,
							count: element.fy_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 4,
							count: element.zz_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 5,
							count: element.sh_count,
						});
					}
					this.peopleData = peopleData;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getAticleData() {
			this.articleInfo["dataRanger"] = [
				this.articleInfo.startDate,
				this.articleInfo.endDate,
			];

			// 接收articleInfo'数据到 tmp，修改tmp数据，不影响articleInfo数据
			var tmp = JSON.parse(JSON.stringify(this.articleInfo));
			if (tmp.is_ai != "999") {
				tmp.is_ai = Number(tmp.is_ai);
			} else {
				tmp.is_ai = null;
			}
			if (tmp.option_type != "999") {
				tmp.option_type = Number(tmp.option_type);
			} else {
				tmp.option_type = null;
			}
			getInformationList(tmp).then((res) => {
				if (res.code == 200) {
					this.articleData = res.data.data;
					for (let index = 0; index < this.articleData.length; index++) {
						const element = this.articleData[index];
						this.articleData[index]["index"] = index + 1;
					}
				} else {
					this.articleData = [];
					this.$message.error("暂无数据");
				}
			});
		},
		initChart(chartData) {
			if (this.myChart) {
				this.myChart.dispose();
			}
			var chartDom = document.getElementById("card_content_tabledata");
			var myChart = echarts.init(chartDom);

			var xAxisData = [];
			var seriesData = [];
			var seriesData_contents = [];
			var seriesData_news = [];
			var seriesData_events = [];
			var seriesData_us = [];
			var seriesData_hk = [];
			var seriesData_columns = [];
			var seriesData_dataera = [];
			var seriesData_aimpact = [];
			var seriesData_poly = [];
			var seriesData_total = []; // 新增 total_count 数据系列

			var seriesData_ios = [];
			var seriesData_android = [];

			for (let index = 0; index < chartData.length; index++) {
				const element = chartData[index];
				xAxisData.push(element.datetime_formatted);
				if (this.pageInfo.type == "app") {
					seriesData_ios.push(element.ios_count);
					seriesData_android.push(element.android_count);
				} else {
					seriesData_contents.push(element.contents_count);
					seriesData_news.push(element.news_count);
					seriesData_events.push(element.events_count);
					seriesData_us.push(element.us_count);
					seriesData_hk.push(element.hk_count);
					seriesData_columns.push(element.columns_count);
					seriesData_dataera.push(element.dataera_count);
					seriesData_aimpact.push(element.aimpact_count);
					seriesData_poly.push(element.poly_count);
				}
			}
			if (this.pageInfo.type == "app") {
				seriesData.push({
					name: "iOS",
					data: seriesData_ios,
				});
				seriesData.push({
					name: "Android",
					data: seriesData_android,
				});
			} else {
				seriesData.push({
					name: "文章",
					data: seriesData_contents,
				});
				seriesData.push({
					name: "快讯",
					data: seriesData_news,
				});
				seriesData.push({
					name: "活动",
					data: seriesData_events,
				});
				seriesData.push({
					name: "US",
					data: seriesData_us,
				});
				seriesData.push({
					name: "HK",
					data: seriesData_hk,
				});
				seriesData.push({
					name: "专栏",
					data: seriesData_columns,
				});
				seriesData.push({
					name: "DataEra",
					data: seriesData_dataera,
				});
				seriesData.push({
					name: "AIMPACT",
					data: seriesData_aimpact,
				});
				seriesData.push({
					name: "预测市场",
					data: seriesData_poly,
				});
			}

			// 新增 total_count 系列
			seriesData.push({
				name: "合计",
				data: seriesData_total,
				type: "line", // 使用折线图显示合计
				smooth: true,
				lineStyle: {
					width: 4,
					type: "solid",
				},
				itemStyle: {
					color: "#FF5722", // 使用不同颜色突出显示
				},
			});

			const option = {
				tooltip: {
					trigger: "axis",
					axisPointer: { type: "shadow" },
					formatter: function (params) {
						// 获取原始数据中的total_count
						const totalCount = chartData[params[0].dataIndex].total_count;
						let result = params[0].axisValue + "<br/>";

						// 添加各系列数据
						params.forEach((item) => {
							result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
						});

						// 添加合计数据
						result += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF5722;"></span>`;
						result += `合计: ${totalCount}<br/>`;

						return result;
					},
				},
				legend: {
					data: seriesData.map((item) => item.name),
					left: "10%", // 图例位置在左上角
					top: "10%",
				},
				xAxis: {
					type: "category",
					data: xAxisData,
				},
				yAxis: {
					type: "value",
				},
				series: seriesData.map((item) => ({
					name: item.name,
					type: "bar",
					stack: "总量", // 启用堆叠效果
					data: item.data,
					emphasis: {
						focus: "self",
					},
				})),
			};

			myChart.setOption(option);
			this.myChart = myChart;
		},
	},
};
</script>

<style scoped>
.main_t {
	width: 100%;
	display: flex;
	justify-content: space-between;
	height: 500px;
}

.main_b {
	width: 100%;
	display: flex;
	height: 860px;
	padding-bottom: 100px;
}

.card_box {
	width: 49%;
	margin-top: 20px;
}

.card_box1 {
	margin-top: 20px;
	width: 100%;
}

.card_content {
	padding: 10px;
}

.card_content_search {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.card_content_search_item_r {
	display: flex;
}
.card_content_search_item_btn {
	margin-left: 10px;
	padding-left: 10px;
	padding-right: 10px;
	height: 30px;
	background: #009688;
	color: #fff;
	border-radius: 6px;
	align-content: center;
	text-align: center;
	align-items: center;
	font-size: 14px;
	flex-shrink: 0;
}

.card_content_search_item_btn_export {
	background: #f26a03;
}
#card_content_tabledata {
	width: 100%;
	height: 400px;
}
.card_content_search_item {
	display: flex;
}
.card_content_search_select {
	display: flex;
	align-items: center;
	margin-left: 20px;
}
.card_content_search_select_title {
	margin-right: 10px;
	font-size: 14px;
	flex-shrink: 0;
}

/* 设置内容全部大写 */
.card_title {
	text-transform: uppercase; /* 将标题内容全部大写 */
}

/* @media screen and (max-width: 1600px) {
	.card_content_search_1 {
		display: block;
	}
} */
</style>

<style scoped>
/* 基础样式 */
.responsive-date-picker {
	width: 100%;
}

.card_content_search_item_btn_export_1 {
	display: none;
}
.card_content_search_item_btn_export_2 {
	display: inline;
}

@media screen and (max-width: 1200px) {
	.card_content_search_item_btn_export_1 {
		display: inline;
	}
	.card_content_search_item_btn_export_2 {
		display: none;
	}
} /* 小屏幕适配 */
@media screen and (max-width: 1500px) {
	.card_content_search_select_item {
		width: 70px !important;
	}
	.card_content_search_select_item::v-deep .el-input__inner {
		padding: 0 5px;
	}
	.card_content_search_select_item::v-deep .el-input__icon {
		width: 15px;
	}
	.card_content_search_select_1 {
		margin-left: 4px;
	}
	.responsive-date-picker::v-deep .el-range-separator,
	.responsive-date-picker::v-deep .el-range__close-icon {
		padding: 0 5px;
		font-size: 12px;
	}
	.responsive-date-picker::v-deep .el-input__inner {
		padding: 0 10px;
	}
	.responsive-date-picker::v-deep .el-range__close-icon {
		width: 0px;
		display: none;
	}

	.responsive-date-picker::v-deep .el-range-input {
		width: 90px;
	}
}
</style>
